var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('navcom',{ref:"navcom"}),_c('router-view'),_c('suspensioncom'),_c('footercom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }